const endpoint = {
	getWeather: '/getWeather' 
};

export default endpoint;
